var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tabs.length
    ? _c("div", { staticClass: "ui-tabs" }, [
        !_vm.accordion
          ? _c("div", { staticClass: "ui-tabs-wrapper" }, [
              _c(
                "ul",
                { ref: "tabs", staticClass: "ui-tabs-tabs" },
                [
                  _vm._l(_vm.tabs, function(tab) {
                    return _c(
                      "li",
                      {
                        key: tab.key,
                        class: { active: tab.active },
                        on: {
                          click: function($event) {
                            return _vm.onClickTab(tab.key)
                          }
                        }
                      },
                      [
                        _vm._v("\n        " + _vm._s(tab.name) + "\n        "),
                        _c("ui-badge", {
                          attrs: { text: tab.badge, color: "#333" }
                        })
                      ],
                      1
                    )
                  }),
                  _c("div", {
                    staticClass: "underline",
                    style: _vm.underlineStyle
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        _c(
          "div",
          { class: ["ui-tabs-content", _vm.currentTab.contentClass] },
          [
            _vm.currentTab.component
              ? _c(_vm.currentTab.component, { tag: "component" })
              : _vm.currentTab.content
              ? _c("div", {
                  staticClass: "html-content",
                  domProps: { innerHTML: _vm._s(_vm.currentTab.content) }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }